import { Smartphone, Tablet, Monitor, MonitorSmartphone } from "lucide-react";
import type { LucideIcon } from "lucide-react";
import type { TFunction } from "i18next";
import type { IClockDevice } from "@/types/(my-space)/timeAttendace.interface";

/* Pick a device icon + visible primary/secondary labels from the clock session.
 * Shared between AttendanceEventCard (a confirmed check-in/out card) and the
 * pending-exception cards (StandardTimeline / DrawerStats), which show a
 * clock attempt still awaiting approval with the same device/location detail.
 * Not a component, so the caller passes its own translator in. */
export const deviceMeta = (
  d: IClockDevice,
  t: TFunction,
): { Icon: LucideIcon; primary: string; secondary: string | null; kind: string } => {
  const s = `${d.device ?? ""} ${d.os ?? ""} ${d.brand ?? ""}`.toLowerCase();
  let Icon: LucideIcon = MonitorSmartphone;
  let kind = t("common:shared_ui.device_kind_device");
  if (/tablet|ipad/.test(s)) {
    Icon = Tablet;
    kind = t("common:shared_ui.device_kind_tablet");
  } else if (/mobile|phone|android|ios|iphone|harmony/.test(s)) {
    Icon = Smartphone;
    kind = t("common:shared_ui.device_kind_mobile");
  } else if (/desktop|windows|mac|linux|ubuntu|pc/.test(s)) {
    Icon = Monitor;
    kind = t("common:shared_ui.device_kind_desktop");
  }
  const primary = d.client || d.device || d.os || t("common:shared_ui.device");
  const secondary =
    d.os && d.os !== primary
      ? d.os
      : d.brand && d.brand !== primary
        ? d.brand
        : null;
  return { Icon, primary, secondary, kind };
};
